<p class="m-0 text-center">{{ updateFailed ? text().UpdateFailedMessage : text().Message }}</p>
<div class="mt-4 flex w-full justify-center">
    <button pButton (click)="buttonAction()">{{ updateFailed ? text().ReloadPage : text().UpdateNow }}</button>
</div>
